import {Aseprite} from '@theatrejs/plugin-aseprite';import data from './hero.json';import texture from './hero.png';export default new Aseprite(texture, data);